export default __webpack_public_path__ + "static/media/GAT-COM.b2d7b369.png";